/* Cart upsell sliders (snippets/ap-cart-upsell.liquid).
   - Related: Shopify product recommendations for the first N cart products,
     interleaved, minus anything already in the cart; padded with / replaced by the
     server-rendered random products.
   - Adding from a card updates the cart page in place (lines + summary) instead of
     opening the UpCart drawer; the other cart sections react to the lines changing.
   - Rebuilds when the cart lines change. */
(function () {
  if (window.__apCartUpsell) return;
  window.__apCartUpsell = true;

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }
  function items(root) {
    return Array.prototype.slice.call(root.querySelectorAll('.ap-upsell__item'));
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  function Upsell(el) {
    this.el = el;
    this.sid = el.dataset.sectionId;
    this.max = parseInt(el.dataset.max, 10) || 12;
    this.sources = parseInt(el.dataset.sources, 10) || 3;
    this.fillRandom = el.dataset.fillRandom === 'true';
    this.relatedTrack = el.querySelector('[data-panel="related"] [data-track]');
    var tpl = el.querySelector('template[data-random]');
    this.random = tpl ? items(tpl.content) : [];
    this.cache = {};
    this.initTabs();
    this.initArrows();
    el.querySelectorAll('[data-track]').forEach(this.initDrag.bind(this));
    if (el.dataset.autoplay) this.initAutoplay(parseInt(el.dataset.autoplay, 10) * 1000);
    this.build();
  }

  Upsell.prototype.activeTrack = function () {
    var panel = this.el.querySelector('.ap-upsell__panel:not([hidden])');
    return panel && panel.querySelector('[data-track]');
  };

  Upsell.prototype.recs = function (productId) {
    var self = this;
    if (!this.cache[productId]) {
      var url = this.el.dataset.recsUrl + '?section_id=' + encodeURIComponent(this.sid) +
        '&product_id=' + productId + '&limit=10&intent=related';
      this.cache[productId] = fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) { return html ? items(parse(html)) : []; })
        .catch(function () { delete self.cache[productId]; return []; });
    }
    return this.cache[productId];
  };

  Upsell.prototype.build = function () {
    var self = this;
    return getCart().then(function (cart) {
      var inCart = {};
      var sources = [];
      cart.items.forEach(function (i) {
        if (!inCart[i.product_id]) sources.push(i.product_id);
        inCart[i.product_id] = true;
      });
      self.inCart = inCart;
      self.el.setAttribute('data-hidden', String(cart.item_count === 0 && self.el.hasAttribute('data-hide-empty')));
      return Promise.all(sources.slice(0, self.sources).map(self.recs.bind(self))).then(function (lists) {
        // Round-robin so every cart item gets a look in near the front.
        var out = [];
        var seen = {};
        var longest = Math.max.apply(null, [0].concat(lists.map(function (l) { return l.length; })));
        for (var n = 0; n < longest; n++) {
          lists.forEach(function (l) {
            var li = l[n];
            if (!li) return;
            var id = li.dataset.productId;
            if (seen[id] || inCart[id]) return;
            seen[id] = true;
            out.push(li);
          });
        }
        var related = out.length > 0;
        if (!related || self.fillRandom) {
          self.random.forEach(function (li) {
            var id = li.dataset.productId;
            if (seen[id] || inCart[id]) return;
            seen[id] = true;
            out.push(li);
          });
        }
        self.render(self.relatedTrack, out.slice(0, self.max));
        self.setRelatedLabel(related);
        // Buy-again list: just drop anything that's now in the cart.
        self.el.querySelectorAll('[data-panel="bought"] .ap-upsell__item').forEach(function (li) {
          li.hidden = !!inCart[li.dataset.productId];
        });
      });
    }).catch(function () {
      if (self.relatedTrack) self.relatedTrack.classList.remove('is-loading');
    });
  };

  Upsell.prototype.render = function (track, list) {
    if (!track) return;
    var frag = document.createDocumentFragment();
    list.forEach(function (li) { frag.appendChild(document.importNode(li, true)); });
    track.innerHTML = '';
    track.appendChild(frag);
    track.scrollLeft = 0;
    track.classList.remove('is-loading');
    // Judge.me stars on cards that were added after its script ran.
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      try { window.jdgm.customizeBadges(); } catch (e) {}
    }
    this.updateArrows();
  };

  Upsell.prototype.setRelatedLabel = function (related) {
    var tab = this.el.querySelector('[data-tab="related"]');
    if (!tab) return;
    var label = related ? tab.dataset.labelRelated : tab.dataset.labelRandom;
    if (label) tab.textContent = label;
  };

  Upsell.prototype.initTabs = function () {
    var self = this;
    var tabs = this.el.querySelectorAll('[data-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', String(on));
        });
        self.el.querySelectorAll('[data-panel]').forEach(function (p) {
          p.hidden = p.dataset.panel !== tab.dataset.tab;
        });
        self.updateArrows();
      });
    });
  };

  Upsell.prototype.initArrows = function () {
    var self = this;
    this.arrows = this.el.querySelectorAll('.ap-upsell__arrow');
    this.arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (self.pauseAutoplay) self.pauseAutoplay();
        var track = self.activeTrack();
        if (!track) return;
        track.scrollBy({ left: track.clientWidth * parseInt(btn.dataset.dir, 10), behavior: 'smooth' });
      });
    });
    this.el.querySelectorAll('[data-track]').forEach(function (track) {
      track.addEventListener('scroll', function () {
        clearTimeout(self._arrowT);
        self._arrowT = setTimeout(self.updateArrows.bind(self), 60);
      }, { passive: true });
    });
  };

  Upsell.prototype.updateArrows = function () {
    var track = this.activeTrack();
    if (!track || !this.arrows || !this.arrows.length) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    this.arrows[0].disabled = track.scrollLeft <= 2;
    this.arrows[1].disabled = track.scrollLeft >= maxScroll;
  };

  // Mouse drag to scroll (touch already scrolls natively). A drag never counts as a click.
  Upsell.prototype.initDrag = function (track) {
    var startX, startLeft, moved = false, down = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true;
      moved = false;
      startX = e.clientX;
      startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) {
        moved = true;
        track.classList.add('is-dragging');
      }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        track.classList.remove('is-dragging');
        // Snap to the nearest card after the drag.
        var first = track.querySelector('.ap-upsell__item');
        if (first) {
          var step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
          track.scrollTo({ left: Math.round(track.scrollLeft / step) * step, behavior: 'smooth' });
        }
      }
    });
    track.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);
  };

  Upsell.prototype.initAutoplay = function (every) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var track = this.relatedTrack;
    if (!track) return;
    var pausedUntil = 0;
    function pause() { pausedUntil = Date.now() + 8000; }
    this.pauseAutoplay = pause;
    ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, pause, { passive: true });
    });
    setInterval(function () {
      if (Date.now() < pausedUntil || document.hidden || !track.offsetParent) return;
      var first = track.querySelector('.ap-upsell__item:not([hidden])');
      if (!first) return;
      var step = first.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step, behavior: 'smooth' });
      }
    }, every);
  };

  // "+" on a card: add to the cart and re-render the cart page in place.
  // Called from a window capture listener (below) so it runs before — and stops —
  // the card snippet's and the apps' document handlers (which open the UpCart drawer).
  Upsell.prototype.onAdd = function (e, btn) {
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) return;
    btn.disabled = true;

    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var ids = [itemsEl && itemsEl.dataset.id, footerEl && footerEl.dataset.id].filter(Boolean);
    var wasEmpty = !!document.querySelector('cart-items.is-empty');
    var li = btn.closest('.ap-upsell__item');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(btn.dataset.variantId, 10), quantity: 1 }],
        sections: ids,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) throw new Error(res.description || res.message);
        if (wasEmpty || !res.sections) {
          window.location.reload();
          return;
        }
        [['main-cart-items', itemsEl], ['main-cart-footer', footerEl]].forEach(function (pair) {
          var el = pair[1];
          var html = el && res.sections[el.dataset.id];
          if (!html) return;
          var fresh = parse(html).querySelector('#' + pair[0] + ' .js-contents');
          var cur = document.querySelector('#' + pair[0] + ' .js-contents');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
        btn.classList.add('is-added');
        if (li) {
          setTimeout(function () { li.classList.add('is-leaving'); }, 500);
          setTimeout(function () { li.remove(); }, 850);
        }
        document.dispatchEvent(new CustomEvent('ap:cart:changed'));
      })
      .catch(function () { btn.disabled = false; });
  };

  var instances = [];
  function init() {
    document.querySelectorAll('[data-ap-upsell]').forEach(function (el) {
      if (el.__apUpsell) return;
      el.__apUpsell = new Upsell(el);
      instances.push(el.__apUpsell);
    });
    var lines = document.querySelector('#main-cart-items .js-contents');
    if (lines && !lines.__apUpsellWatch) {
      lines.__apUpsellWatch = true;
      var t;
      new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(function () { instances.forEach(function (u) { u.build(); }); }, 600);
      }).observe(lines, { childList: true });
    }
  }
  window.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ap-upsell] .ap-upcart-trigger');
    if (!btn) return;
    var el = btn.closest('[data-ap-upsell]');
    if (el.__apUpsell) el.__apUpsell.onAdd(e, btn);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
